import { Grid, Space } from "../Layout";
import { Texts, Title, Media, Button, Link } from "../Object";
import { VoiceList } from "../Post";

const Voice = (props) => {
  const gridProps = {
    list: {
      gap: ['64px', '24px'],
      layout: ['repeat(3, 1fr)', '100%'],
      size: '100%',
    }
  }
  
  return (
    <>
      <div className="p-voice__wrap">
        <div className="l-row">
          <Title slug="voice"></Title>
          <Space size={["100px 0 80px", "64px 0 48px"]}>
            <Grid {...gridProps.list}>
              <VoiceList></VoiceList>
            </Grid>
          </Space>
          <Button type="center" slug="voice" link="/voice/"></Button>
        </div>
      </div>
    </>
  );
};

export default Voice;
